import Chip from "@material-ui/core/Chip";
import Button from "@material-ui/core/Button/Button"
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select/Select";
import * as React from "react";
import { IChildrenOnlyProps } from "./ichildren-only-props";

export const ChipWrapper = (props: IChildrenOnlyProps) => <div style={wrapper}>{props.children}</div>;

export const TagList = (props: { tags: string[] }) => <ChipWrapper>
    {props.tags ? props.tags.map((tag, index) => <Tag key={index}>{tag}</Tag>) : null}
</ChipWrapper>;

export const Tag = (props: IChildrenOnlyProps) => <Chip style={{ margin: 4 }} label={props.children} />;

const wrapper: React.CSSProperties = {
    display: 'flex',
    flexWrap: 'wrap'
}

export const Spacer = (props: {}) => <div style={{ clear: 'both', height: 20 }} />;

export const ListMenuItem = (props: any) => <ListItem button={true} divider={true} onClick={props.onClick} className={props.className}>
    {props.icon}
    <ListItemText>{props.children}</ListItemText>
</ListItem>;

export interface ISelectFieldProps {
    label: string;
    fullWidth?: boolean;
    value: string | number;
    className?: string;
    name: string;
    onChange: (event: React.ChangeEvent<HTMLSelectElement>, child: React.ReactNode) => void;
}

export class SelectField extends React.Component<ISelectFieldProps, any> {
    public render() {
        const props = this.props;
        return <FormControl className={props.className} fullWidth={props.fullWidth}>
            <InputLabel>{props.label}</InputLabel>
            <Select value={props.value} inputProps={{ name: props.name }} onChange={props.onChange}>
                <MenuItem value=""><em>Select item</em></MenuItem>
                {props.children}
            </Select>
        </FormControl>;
    }
}
 export interface IExceptionProps {
    className?: string;
    type?: '403' | '404' | '500' | 'JsError';
    title?: React.ReactNode;
    desc?: React.ReactNode;
    img?: string;
    actions?: React.ReactNode;
    linkElement?: React.ReactNode;
    style?: React.CSSProperties;
    stack?: string;
    componentStack?: string;
}
 
interface ErrorConfig {
    title: string;
    desc?: React.ReactNode;
}
 
const typeConfig: { [key: string]: ErrorConfig } = {
    '403': {
        title: 'Forbidden',
        desc: "Sorry, you don't have access to this page",
    },
    '404': {
        title: 'Not Found',
        desc: 'Sorry, the page you are looking for does not exist',
    },
    '500': {
        title: 'Error',
        desc: 'An internal server error occurred',
    },
    'JsError': {
        title: 'Script Error',
        desc: "A scripting error occurred",
    },
};
 
export const Exception = ({ className, linkElement = 'a', type, title, desc, actions, ...rest }: IExceptionProps) => {
    let errorConf;
    let pageType = type;
    if (!pageType || !typeConfig[pageType]) {
        errorConf = typeConfig["404"];
    } else {
        errorConf = typeConfig[pageType];
    }

    return (
        <div {...rest}>
            <div>
                <div
                />
            </div>
            <div>
                <h1>{title || errorConf.title}</h1>
                <div>{desc || errorConf.desc}</div>
                {rest.stack && <div>
                    <p>Stack Trace</p>
                    <div>{rest.stack}</div>
                </div>}
                {rest.componentStack && <div>
                    <p>Component Stack Trace</p>
                    <div>{rest.componentStack}</div>
                </div>}
                <div>
                    {actions || React.createElement(linkElement as any,
                        {
                            to: '/',
                            href: '/',
                        },
                        <Button type="primary">Return to Home</Button>
                    )}
                </div>
            </div>
        </div>
    );
};
 



// WEBPACK FOOTER //
// ./src/components/utility-components.tsx